import * as React from "react";
import {LoadingSpinner} from "../util/LoadingSpinner";
import * as _ from "lodash";
import {AppCtx} from "../../ioc/ApplicationContext";
import {UserStoreState} from "../../store/UserStore";
import {extractPathParams, toPathParams} from "../../utils/UrlUtils";


export interface LoadingViewState {
    loading?: boolean;
    loadingFailed?: boolean;
    operatorId?: number;
    role?: string;
    initialized?: boolean;
}

export abstract class RouterView<P, S extends LoadingViewState> extends React.Component<P, S> {

    unsubscribe: () => void;
    static contextTypes: React.ValidationMap<any> = {
        router: React.PropTypes.any.isRequired
    };


    constructor(props?: P) {
        super(props);
        var userStoreState = AppCtx.getUserStore().getState();
        this.state = {
            loading: true,
            initialized: false,
            loadingFailed: false,
            operatorId: userStoreState.activeOperator,
            role: userStoreState.activeRole
        } as any;
        console.log("Router view state = ", this.state);
    }

    componentDidMount() {
        this.unsubscribe = AppCtx.getUserStore().listen((state: UserStoreState) => {
            this.setState({role: state.activeRole, operatorId: state.activeOperator} as any);
        });
        this.refreshContent();
    }

    refreshContent() {
        this.setState({loading: true} as any);
        let promise = this.loadContent() as Promise<any>;
        if (promise) {
            promise.then(() => {
                setTimeout(() => this.setState({loading: false, initialized: true} as any), 0);
            }).catch(err => {
                this.setState({loading: false, loadingFailed: true} as any)
            });
        } else {
            setTimeout(() => this.setState({loading: false} as any), 0);
        }
    }

    abstract loadContent(): Promise<any> | void;

    componentDidUpdate(prevProps, prevState) {
        if (this.state.operatorId != prevState.operatorId) {
            this.refreshContent();
        }
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    context: { router: any };

    navigate(path: string) {
        this.context.router.push(path);
    }

    setLoading(loading: boolean) {
        this.setState(((state) => {
            return _.merge(state, {loading: loading, loadingFailed: false});
        }));
    }

    setErrorLoading() {
        this.setState(((state) => {
            return _.merge(state, {loading: false, loadingFailed: true});
        }));
    }

    /**
     * @deprecated return a Promise.all() in loadContent instead
     * @param promises
     * @returns {Promise<T>}
     */
    loadAll(...promises: Promise<any>[]) {
        var promise = new Promise((resolve, reject) => {
            Promise.all(promises).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
        return promise;

    }

    load<L>(p: Promise<L>): Promise<L> {
        this.setLoading(true);
        var promise = new Promise<L>((resolve, reject) => {
            p.then((res: L) => {
                resolve(res);
            }).catch(err => {
                reject(err);
                console.log("ERROR LOADING", err);
                this.setErrorLoading();
            });
        });
        return promise;
    }

    toPathParams(target: any): string {
        return toPathParams(target);
    }

    updatePathParams(base: string, target: any) {
        var params = this.toPathParams(target);
        console.log("PARAMS = ", params);
        this.navigate(base + params);
    }

    abstract renderContent(): JSX.Element;

    isShowContentWhenOnRefresh(): boolean {
        return false;
    }

    render() {
        let showLoading = this.state.loading;
        if (this.isShowContentWhenOnRefresh() == true && this.state.initialized == true) {
            showLoading = false;
        }
        if (this.state.loadingFailed == true) {
            return (
                <div className="wrapper wrapper-content animated">
                    <div className="middle-box text-center fadeInDown">
                        <h1>500</h1>
                        <h2 className="font-bold danger">Oops! Something went wrong...</h2>

                        <div className="error-desc">
                            Try reloading, if the error persists please contact support
                        </div>
                    </div>
                </div>
            );
        } else if (showLoading == true) {
            return (
                <div className="wrapper wrapper-content animated">
                    <div className="row">
                        <div className="col-lg-12 loading-content">
                            <LoadingSpinner/>
                        </div>
                    </div>
                </div>
            );
        } else {
            return this.renderContent();
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/view/RouterView.tsx